<script setup lang="ts">
import { defineEmits } from 'vue'
import i18n from '@/lang/i18n';

const emits = defineEmits(['openModal'])
const props = defineProps<{
  messages: string[]
  showModalButton: boolean
}>()

const showMaxLength = 3 as number
const btnName = i18n.global.t('pages.dailyReports.errorAllDisplay') as string

function openModal() {
  emits('openModal')
}
</script>
<template>
  <div
    v-for="(message, index) in props.messages" :key="index"
    class="d-flex justify-content-end"
  >
    <div
      v-if="index < showMaxLength"
      class="d-flex justify-content-end w-100"
    >
      <label
        class="align-middle"
        style="color: crimson; margin: 0"
      >
        {{ message }}
      </label>
    </div>
  </div>
  <div
    class="d-flex justify-content-end"
  >
    <div>
      <div
        v-if="props.messages.length > showMaxLength"
        class="d-flex justify-content-end"
        style="color: crimson;"
      >
        <span class="material-symbols-outlined">
          more_horiz
        </span>
      </div>
      <v-btn
        v-if="props.showModalButton"
        class="mt-2"
        color="#FF5722"
        style="color: white"
        @click="openModal()"
      >
        {{ btnName }}
      </v-btn>
    </div>
  </div>
</template>